/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { InsightsResponseSchema } from './insightsResponseSchema';
import type { PublicChatMessageSchema } from './publicChatMessageSchema';
import type { PublicShareMetaSchema } from './publicShareMetaSchema';
import type { PublicShareProfileSchema } from './publicShareProfileSchema';
import type { PublicShareResponseSchemaFilters } from './publicShareResponseSchemaFilters';
import type { PublicShareResponseSchemaSpotlights } from './publicShareResponseSchemaSpotlights';
import type { ShareConfig } from './shareConfig';

export interface PublicShareResponseSchema {
  search_id: string;
  expires_at: string;
  created_at: string;
  total_count: number;
  config: ShareConfig;
  candidates?: PublicShareProfileSchema[] | null;
  insights?: InsightsResponseSchema | null;
  chat?: PublicChatMessageSchema[] | null;
  meta: PublicShareMetaSchema;
  filters?: PublicShareResponseSchemaFilters;
  spotlights?: PublicShareResponseSchemaSpotlights;
}
